export default {
  status                    : {
    initializing              : false,
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  menus: [],
  subMenus: [],
  role: [],
  roles: [],
  eventLogs: [],
  loginLogs: [],
  transactionLogs: [],
  importLogs: [],
  maintenances: [],
  config: null,
  configSinger: null,
}
